import { Helmet } from 'react-helmet';
import LayoutDashboard from '../../../../components/layouts/layout_dashboard';
import CustomHeader from '../../../../components/customs/header';
import BtnBack from '../../../../components/buttons/btn_back';
import BtnDefault from '../../../../components/buttons/btn_default';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faPrint, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getPiutang, showPiutang } from '../../../../services/finance/piutang_service';
import CustomCurrency from '../../../../components/customs/currency';
import FormatDate from '../../../../components/format/date';
import InputDefault from '../../../../components/form/input_default';
import { showDebiturCreditur } from '../../../../services/user_management/debitur_creditur_service';
import PiutangCreate from './create';
import FormatDateV2 from '../../../../components/format/date_v2';
import CustomAlert from '../../../../components/customs/alert';
import CustomConfirm from '../../../../components/customs/confirm';
import TransactionUpdate from '../transaction/update';
import SubmitUpdate from '../transaction/function_update';
const PiutangDetail = () => {
    const [accessToken, setAccessToken] = useState("")
    const [userRole, setUserRole] = useState("")
    const navigate = useNavigate()
    const { id } = useParams()

    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)

    const [openCreate, setOpenCreate] = useState(false)

    const [debit, setDebit] = useState(0)
    const [credit, setCredit] = useState(0)
    const [dataCreditur, setDataCreditur] = useState(null)
    const [data, setData] = useState([])
    const fetchData = async (accessToken) => {
        setLoading(true)
        try {
            const response = await showPiutang(accessToken, id)
            if (response.status === 200) {
                setDebit(response.data.debit)
                setCredit(response.data.credit)
                setData(response.data.data);
                setDataCreditur(response.data.creditur)
            }
        } catch (error) {
            console.log("__")
        }
        setLoading(false)
    }


    useEffect(() => {
        if (refresh) {
            fetchData(accessToken)
            setRefresh(false)
        }
    }, [refresh])

    useEffect(() => {
        const getAccessToken = localStorage.getItem('access_token-terra_app')
        const getUserRole = localStorage.getItem('user_role-terra_app')

        setAccessToken(getAccessToken)
        fetchData(getAccessToken)
    }, [])

    const totalDebit = data.reduce((total, item) => {
        return item?.category?.name === 'piutang' ? total + item.nominal : total; // Hitung total debit
    }, 0);

    const totalKredit = data.reduce((total, item) => {
        return item?.category?.name === 'piutang dibayar' ? total + item.nominal : total; // Hitung total debit
    }, 0);

    const [openAlert, setOpenAlert] = useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [typeAlert, setTypeAlert] = useState("")

    const [openUpdate, setOpenUpdate] = useState(false)
    const [dataUpdate, setDataUpdate] = useState(null)
    const [deletedId, setDeletedId] = useState("")
    const [loadingDelete, setLoadingDelete] = useState(false)
    const [categoryUpdate, setCategoryUpdate] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)

    return (
        <>
            <Helmet>
                <title>Detail Piutang</title>
            </Helmet>
            <LayoutDashboard>
                <CustomHeader>
                    <BtnBack />
                    <p className='text-center'>Detail Piutang</p>
                    <div className="flex items-center justify-end gap-3">
                        <BtnDefault handleClick={() => navigate(`print`)}>
                            <FontAwesomeIcon icon={faPrint} />
                            <p className="hidden md:flex">Print</p>
                        </BtnDefault>
                        <BtnDefault handleClick={() => setOpenCreate(true)}>
                            <FontAwesomeIcon icon={faPlus} />
                            <p className="hidden md:flex">Transaksi Baru</p>
                        </BtnDefault>
                    </div>
                </CustomHeader>

                <div className="px-3 pt-3 flex items-start justify-between">
                    <div className="w-full">
                        <table className={`font-semibold`}>
                            {loading ?
                                Array.from({ length: 3 }).map(() => (
                                    <tr>
                                        {Array.from({ length: 2 }).map(() => (
                                            <td className="px-3 py-2 w-32">
                                                <div className="w-full h-5 bg-gray-300 rounded-full" />
                                            </td>
                                        ))}
                                    </tr>
                                )) :
                                <>
                                    <tr>
                                        <td>ID</td>
                                        <td className="px-3">:</td>
                                        <td>{dataCreditur?.id}</td>
                                    </tr>
                                    <tr>
                                        <td>Nama</td>
                                        <td className="px-3">:</td>
                                        <td className="capitalize">{dataCreditur?.name}</td>
                                    </tr>
                                    <tr>
                                        <td>Kategori</td>
                                        <td className="px-3">:</td>
                                        <td className="capitalize">{dataCreditur?.category?.name}</td>
                                    </tr>
                                </>
                            }
                        </table>
                    </div>
                    <div>
                        <table className="font-semibold">
                            {loading ?
                                Array.from({ length: 3 }).map(() => (
                                    <tr>
                                        {Array.from({ length: 2 }).map(() => (
                                            <td className="px-3 py-2 w-32">
                                                <div className="w-full h-5 bg-gray-300 rounded-full" />
                                            </td>
                                        ))}
                                    </tr>
                                )) :
                                <>
                                    <tr>
                                        <td>Total Piutang</td>
                                        <td className="px-2">:</td>
                                        <td><CustomCurrency value={totalDebit} /></td>
                                    </tr>
                                    <tr>
                                        <td className="w-[250px]">Total Piutang Dibayar</td>
                                        <td className="px-2">:</td>
                                        <td><CustomCurrency value={totalKredit} /></td>
                                    </tr>
                                    <tr>
                                        <td>Sisa Piutang</td>
                                        <td className="px-2">:</td>
                                        <td><CustomCurrency value={totalDebit - totalKredit} /></td>
                                    </tr>
                                </>
                            }
                        </table>
                    </div>
                </div>

                <div className='w-full px-3'>
                    <table className={`max-w-screen-2xl ${data?.length === 0 || loading === true ? 'min-w-max md:min-w-full' : 'min-w-max'}`}>
                        <thead className="bg-custom-dark-yellow text-custom-navy sticky top-[130px] text-sm">
                            <tr className="">
                                <th className="px-3 py-2 rounded-tl-xl" >No</th>
                                <th className="px-3 py-2" colSpan={2}>Aksi</th>
                                <th className="px-3 py-2" >Tanggal</th>
                                <th className="px-3 py-2" >Kode Transaksi</th>
                                <th className="px-3 py-2" >Kategori Transaksi</th>
                                <th className="px-3 py-2" >Jenis Peruntukan</th>
                                <th className="px-3 py-2" >Nominal</th>
                                <th className="px-3 py-2 rounded-tr-xl">Keterangan</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ? "Loading..!" :
                                    data?.length === 0 ?
                                        <tr className="">
                                            <td className="px-3 py-2" colSpan={20}>
                                                Tidak ada transaksi..!
                                            </td>
                                        </tr> :
                                        data.map((item, index) => (
                                            <>
                                                <tr className={`${index % 2 === 1 ? 'bg-gray-200' : ''} hover:bg-gray-400 transition-colors`}>
                                                    <td className="px-3 py-2  text-center" >{index + 1}</td>
                                                    <td className="px-3 py-2  text-center" >
                                                        <button
                                                            type='button'
                                                            onClick={() => {
                                                                setDeletedId(item?.id)
                                                                setDataUpdate(item)
                                                                setCategoryUpdate("delete")
                                                                // setOpenConfirm(true)
                                                                setOpenUpdate(true)
                                                            }}
                                                            className='text-white bg-red-500 rounded-md px-3 py-2 hover:bg-red-600 transition-colors'
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                    <td className="px-3 py-2  text-center" >
                                                        <button
                                                            type='button'
                                                            onClick={() => {
                                                                setDataUpdate(item)
                                                                setCategoryUpdate("update")
                                                                setOpenUpdate(true)
                                                            }}
                                                            className='text-white bg-yellow-500 rounded-md px-3 py-2 hover:bg-yellow-600 transition-colors'
                                                        >
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                    </td>
                                                    <td className="px-3 py-2  " >
                                                        <FormatDateV2 date={item?.date} />
                                                    </td>
                                                    <td className="px-3 py-2  ">
                                                        {item?.code}
                                                    </td>
                                                    <td className="px-3 py-2  ">
                                                        {item?.category?.name}
                                                    </td>
                                                    <td className="px-3 py-2  ">
                                                        {item?.account_from?.id}  -
                                                        {item?.account_from?.name}
                                                    </td>
                                                    <td className="px-3 py-2  text-end">
                                                        <CustomCurrency value={item?.nominal} />
                                                    </td>
                                                    <td className="px-3 py-2  max-w-[500px]">
                                                        {item?.description}
                                                    </td>
                                                </tr >
                                            </>
                                        ))}
                            <tr>
                                <td colSpan={20} className="px-3 py-5 text-center bg-custom-dark-yellow" />
                            </tr>
                        </tbody>
                    </table>
                </div>

                <CustomAlert open={openAlert} setOpen={setOpenAlert} message={messageAlert} type={typeAlert} />

                <PiutangCreate
                    open={openCreate} setOpen={setOpenCreate}
                    setRefresh={setRefresh}
                    accessToken={accessToken}
                    getCrediturId={id}
                    getTotalPiutang={totalDebit - totalKredit}
                    detail={true}
                    setOpenAlert={setOpenAlert}
                    setTypeAlert={setTypeAlert}
                    setMessageAlert={setMessageAlert}
                />

                <TransactionUpdate
                    accessToken={accessToken}
                    open={openUpdate} setOpen={setOpenUpdate}
                    setRefresh={setRefresh}
                    data={dataUpdate}
                    setOpenAlert={setOpenAlert} setMessageAlert={setMessageAlert} setTypeAlert={setTypeAlert}
                    category={categoryUpdate}
                />


                <CustomConfirm
                    handleConfirm={(e) => {
                        const paramData = {
                            "id": deletedId,
                            "category": "delete"
                        }

                        SubmitUpdate(
                            e,
                            accessToken,
                            paramData,
                            loadingDelete,
                            setLoadingDelete,
                            false,
                            null,
                            setOpenAlert,
                            setMessageAlert,
                            setTypeAlert
                        )
                    }}
                    message={"Apakah Anda yakin akan melakukan permintaan hapus data..?"}
                    open={openConfirm}
                    setOpen={setOpenConfirm}
                />

            </LayoutDashboard >
        </>
    )
}

export default PiutangDetail